import React from 'react';

import { Svg } from '@lglp/components';

import styles from './Arrow.module.scss';

export enum ArrowOrientation {
  TOP,
  LEFT,
  RIGHT,
  BOTTOM,
}

const Arrow: React.FC<ArrowProps> = (props) => {
  const { orientation = ArrowOrientation.RIGHT, className, ...rest } = props;

  let orientationClassName = styles.right;
  switch (orientation) {
    case ArrowOrientation.LEFT: {
      orientationClassName = styles.left;
      break;
    }
    case ArrowOrientation.TOP: {
      orientationClassName = styles.top;
      break;
    }
    case ArrowOrientation.BOTTOM: {
      orientationClassName = styles.bottom;
      break;
    }
    case ArrowOrientation.RIGHT:
    default: {
      orientationClassName = styles.right;
      break;
    }
  }

  return (
    <Svg
      className={[styles.arrow, orientationClassName, className]}
      viewBox="0 0 32 10"
      {...rest}
    >
      <path
        d="M24.86 7l5.172-3.043L24.775 1m5.265 2.957h-29"
        transform="translate(-.04 .362)"
      />
    </Svg>
  );
};

type ArrowProps = {
  orientation?: ArrowOrientation;
  className?: string;
};

export default Arrow;
